// Sample site JS
const Theme = (function () {
  const KEY = 'clinicapp:theme';

  function applyTheme(theme) {
    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else if (theme === 'light') {
      document.documentElement.removeAttribute('data-theme');
    }
  }

  function getSystemPrefersDark() {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  function getStoredTheme() {
    try { return localStorage.getItem(KEY); } catch (e) { return null; }
  }

  function setStoredTheme(value) {
    try { if (value) localStorage.setItem(KEY, value); else localStorage.removeItem(KEY); } catch (e) {}
  }

  function init() {
    const stored = getStoredTheme();
    if (stored) applyTheme(stored);
    else if (getSystemPrefersDark()) applyTheme('dark');

    // Listen for system changes only when no stored preference
    if (!stored && window.matchMedia) {
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
        applyTheme(e.matches ? 'dark' : 'light');
      });
    }
  }

  function toggle() {
    const current = getStoredTheme() || (getSystemPrefersDark() ? 'dark' : 'light');
    const next = current === 'dark' ? 'light' : 'dark';
    setStoredTheme(next);
    applyTheme(next);
    return next;
  }

  return { init, toggle, getStoredTheme };
})();

/**
 * Page Loader Module
 * Handles the page loading animation and app shell visibility
 */
const PageLoader = (function () {
  let loader = null;
  let appShell = null;

  function init() {
    loader = document.getElementById('pageLoader');
    appShell = document.getElementById('appShell');

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hide);
    } else {
      hide();
    }

    window.addEventListener('load', hide);
  }

  function hide() {
    if (!loader || !appShell) {
      return;
    }

    loader.classList.add('loaded');
    appShell.classList.add('loaded');

    setTimeout(function () {
      if (loader) {
        loader.style.display = 'none';
      }
    }, 300);
  }

  function show() {
    if (!loader || !appShell) {
      return;
    }

    loader.style.display = 'flex';
    loader.classList.remove('loaded');
    appShell.classList.remove('loaded');
  }

  return { init, hide, show };
})();

document.addEventListener('DOMContentLoaded', function () {
  Theme.init();
  PageLoader.init();

  const toggle = document.getElementById('theme-toggle');
  if (toggle) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      const next = Theme.toggle();
      // update label/icon
      this.setAttribute('aria-pressed', next === 'dark');
      this.textContent = next === 'dark' ? '🌙' : '☀️';
    });
    // Initialize label
    const initial = Theme.getStoredTheme() || (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    toggle.setAttribute('aria-pressed', initial === 'dark');
    toggle.textContent = initial === 'dark' ? '🌙' : '☀️';
  }

  // Sidebar toggle behaviour
  const sidebarToggle = document.getElementById('sidebarToggle');
  const sidebarToggleMobile = document.getElementById('sidebarToggleMobile');
  const sidebarCollapseBtn = document.getElementById('sidebarBottomBtn');
  const body = document.body;

  function openSidebar() { body.classList.add('sidebar-open'); }
  function closeSidebar() { body.classList.remove('sidebar-open'); }
  function toggleSidebar() { if (body.classList.contains('sidebar-open')) closeSidebar(); else openSidebar(); }
  function setSidebarState(visible) { if (visible) { openSidebar(); setOverlayVisible(true); } else { closeSidebar(); setOverlayVisible(false); } }

  if (sidebarToggle) {
    sidebarToggle.addEventListener('click', function (e) {
      e.preventDefault(); toggleSidebar(); setOverlayVisible(body.classList.contains('sidebar-open'));
    });
  }
  if (sidebarToggleMobile) {
    sidebarToggleMobile.addEventListener('click', function (e) {
      e.preventDefault(); toggleSidebar(); setOverlayVisible(body.classList.contains('sidebar-open'));
    });
  }

  // Desktop collapse toggle: persist collapsed state
  const COLLAPSE_KEY = 'clinicapp:sidebar-collapsed';

  function setCollapsedState(collapsed) {
    if (collapsed) {
      document.body.classList.add('sidebar-collapsed');
      sidebarCollapseBtn && sidebarCollapseBtn.setAttribute('aria-pressed', 'true');
      sidebarCollapseBtn && (sidebarCollapseBtn.querySelector('i').className = 'bi bi-chevron-double-right');
    } else {
      document.body.classList.remove('sidebar-collapsed');
      sidebarCollapseBtn && sidebarCollapseBtn.setAttribute('aria-pressed', 'false');
      sidebarCollapseBtn && (sidebarCollapseBtn.querySelector('i').className = 'bi bi-chevron-double-left');
    }
    try { localStorage.setItem(COLLAPSE_KEY, collapsed ? '1' : '0'); } catch (e) {}
  }

  // initialize collapsed state from storage — default to collapsed
  (function () {
    try {
      const v = localStorage.getItem(COLLAPSE_KEY);
      setCollapsedState(v !== '0');
    } catch (e) {
      setCollapsedState(true);
    }
  })();

  // hover expand when collapsed (desktop)
  const sidebarEl = document.getElementById('sidebar');
  if (sidebarEl) {
    sidebarEl.addEventListener('mouseenter', function () {
      if (document.body.classList.contains('sidebar-collapsed')) {
        document.body.classList.add('sidebar-expanded');
      }
    });
    sidebarEl.addEventListener('mouseleave', function () {
      document.body.classList.remove('sidebar-expanded');
    });
  }

  if (sidebarCollapseBtn) {
    sidebarCollapseBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const now = document.body.classList.contains('sidebar-collapsed');
      setCollapsedState(!now);
    });
  }

  // Close sidebar when clicking outside on mobile
  const sidebarOverlay = document.getElementById('sidebarOverlay');

  function setOverlayVisible(visible) {
    if (!sidebarOverlay) return;
    sidebarOverlay.style.pointerEvents = visible ? 'auto' : 'none';
  }

  // clicking overlay closes sidebar
  if (sidebarOverlay) {
    sidebarOverlay.addEventListener('click', function (e) { closeSidebar(); });
  }

  document.addEventListener('click', function (e) {
    const sidebar = document.getElementById('sidebar');
    if (!sidebar) return;
    if (window.innerWidth <= 768 && body.classList.contains('sidebar-open')) {
      const inside = sidebar.contains(e.target) || (sidebarToggle && sidebarToggle.contains(e.target)) || (sidebarToggleMobile && sidebarToggleMobile.contains(e.target));
      if (!inside) closeSidebar();
    }
    setOverlayVisible(body.classList.contains('sidebar-open'));
  });
});

// Expose PageLoader to global scope for potential reuse
window.PageLoader = PageLoader;
